import {
  PAGO_COBROS_REQUEST,
  PAGO_COBROS_SUCCESS,
  PAGO_COBROS_ERROR,
  PAGO_COBROS_RESET,
} from "redux/types/pagoCobrosTypes";

const initialState = {
  data: null,   // { totalFacturas, ingresosMes, porCobrarCantidad, porCobrarValor,
                //   totalNC, valorNC, totalGastos, valorGatos, utilidadNeta,
                //   cobradoCantidad, cobradoValor }
  loading: false,
  error: null,
};

const pagoCobrosReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGO_COBROS_REQUEST:
      return { ...state, loading: true, error: null };

    case PAGO_COBROS_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };

    case PAGO_COBROS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case PAGO_COBROS_RESET:
      return initialState;

    default:
      return state;
  }
};

export default pagoCobrosReducer;
